import React from "react";
import Modal from "react-responsive-modal";
import autoBind from "react-autobind";
import Camera from "./camera";


class CameraModal extends React.PureComponent {

	constructor(props) {
		super(props);
		autoBind(this);
	}

	onClose() {
		if (this.props.onClose) {
			this.props.onClose();
		}
	}

	onAccept(event) {
		if (this.props.onAccept) {
			this.props.onAccept(event);
		}
	}

	render() {
		let modal = <Modal
			open={this.props.isOpen}
			onClose={this.onClose} classNames={{ overlay: "ambifi-player-web", modal: "custom-modal" }} closeButton>
			<div style={{ display: "flex", flexDirection: "column", alignItems: "center", padding: "12px" }}>
				<h4>{this.props.title}</h4>
				<Camera onAccept={this.onAccept} mode={this.props.mode} showModeSelector={this.props.showModeSelector} />
			</div>
		</Modal>

		return modal;
	}

}

export default CameraModal;